import React from 'react';

const OrderTransfersCard = ({ tickets }) => {
  const transferred = tickets.filter((t) => t.transferred);
  if (transferred.length === 0) return null;

  const summary = transferred.length === 1
    ? '1 ticket on this order was transferred to another fan.'
    : `${transferred.length} tickets on this order were transferred to another fan.`;

  return (
    <div className="op-card op-transfers-card">
      <h2 className="op-section-title">Ticket Transfers</h2>
      <p className="op-muted op-transfers-note">{summary}</p>
      <ul className="op-transfers-list">
        {transferred.map((t) => (
          <li key={`${t.kind}-${t.id}`} className="op-transfers-item">
            <span className="op-field">{t.productName}</span>
            <span className="op-muted">
              {`Transferred to ${t.transferredToName || 'another fan'}`}
              {t.transferredOn ? ` on ${t.transferredOn}` : ''}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OrderTransfersCard;
